import store from '@/store'

// Amount/quantity formatting with Intl.NumberFormat (PRODTI-352 / AXTDEV-372).
// Locale = browser (navigator.language); currency = view data.

// Cache instances by (locale + options): building the formatter is the expensive part.
const cache = new Map()

const getFormatter = (locale, options) => {
  const key = `${locale}|${JSON.stringify(options)}`
  let formatter = cache.get(key)
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options)
    cache.set(key, formatter)
  }
  return formatter
}

const isEmpty = (value) => value === null || value === undefined || value === ''

// Backend may return the amount as number or string; null/NaN → null (renders nothing).
const toNumber = (value) => {
  if (isEmpty(value)) return null
  const number = typeof value === 'number' ? value : Number(value)
  return Number.isNaN(number) ? null : number
}

export const resolveLocale = () => navigator.language || 'es-CL'

export const resolveCurrency = (item = {}) => item?.currency || store.state.auth?.account?.currency || null

export const formatInteger = (locale, amount) => {
  const number = toNumber(amount)
  if (number === null) return ''
  return getFormatter(locale, { maximumFractionDigits: 0 }).format(number)
}

export const formatDecimal = (locale, amount, decimals = 2) => {
  const number = toNumber(amount)
  if (number === null) return ''
  return getFormatter(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(number)
}

// Raw Intl output: symbol, position and decimals are decided by the locale/currency. Not parsed.
export const formatCurrency = (locale, currency, amount) => {
  const number = toNumber(amount)
  if (number === null || !currency) return ''
  try {
    return getFormatter(locale, { style: 'currency', currency, currencyDisplay: 'symbol' }).format(number)
  } catch (e) {
    return formatInteger(locale, number)
  }
}

const fmt = {
  currency: (currency, amount) => formatCurrency(resolveLocale(), currency, amount),
  integer: (amount) => formatInteger(resolveLocale(), amount),
  decimal: (amount, decimals) => formatDecimal(resolveLocale(), amount, decimals)
}

export default {
  install (Vue) {
    Vue.prototype.$fmt = fmt
  }
}
